<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Netto omzet
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Vermeld het totale bedrag aan leveringen en/of diensten die in het boekjaar zijn verricht.</p>
                <p>De netto-omzet is de bruto-omzet minus:</p>
                <ul>
                    <li>de btw die over de omzet is geheven.</li>
                    <li>kortingen en dergelijke.</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Mutatie voorraden gereed product en onderhanden werk
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Vermeld de positieve of negatieve waardeverandering van de voorraad gereed product of onderhanden
                    werk. Bij onderhanden werk gaat het om langlopende projecten en opdrachten zoals een bouwwerk
                    waaraan langere tijd wordt gewerkt.</p>
                <b>Onderhanden werk en onderhanden opdrachten</b>
                <p>Bij de waardering van onderhanden werk en onderhanden opdrachten geldt het volgende:</p>
                <ul>
                    <li>Het zogenoemde constante deel van de algemene kosten moet ook worden geactiveerd. Dit zijn
                        bijvoorbeeld loonkosten van de algemene leiding en huisvestingskosten.
                    </li>
                    <li>De winst moet voortschrijdend worden genomen. Je mag dus niet wachten met winstneming tot het
                        werk of de opdracht is afgerond. Als een opdracht voor de helft klaar is, dan moet je de helft
                        van de overeengekomen prijs op dat moment activeren. Dit activeren leidt vervolgens tot
                        winstneming.
                    </li>
                </ul>
                <b>Praktische afspraken waarderingsregels onderhanden werk</b>
                <p>De Belastingdienst heeft afspraken gemaakt met brancheorganisaties over de waardering van onderhanden
                    werk. De afspraken verminderen de administratieve lasten voor bedrijven. Je vindt de afspraken in de
                    <a href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/themaoverstijgend/brochures_en_publicaties/uitwerking_waardering_onderhanden_werk"
                       target="_blank">'Uitwerking waardering onderhanden werk'</a>.
                </p>

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Overige opbrengsten
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Onder 'Overige opbrengsten' vallen bijvoorbeeld:</p>
                <ul>
                    <li>geactiveerde productie voor het eigen bedrijf.</li>
                    <li>de opwaardering van vlottende activa in dit boekjaar.</li>
                    <li>vergoedingen die de vennootschap heeft ontvangen in het kader van een subsidieregeling voor
                        agrarisch natuurbeheer (voor agrariërs).
                    </li>
                    <li>de opbrengsten die de vennootschap heeft behaald met werk dat aan de vennootschap is uitbesteed
                        (voor agrariërs).
                    </li>
                    <li>de vergoeding die de vennootschap heeft ontvangen voor het ter beschikking stellen van
                        faciliteiten voor het opfokken van dieren (voor agrariërs).
                    </li>
                </ul>
                <b>Geachtiveerde productie voor het eigen bedrijf</b>
                <p>Vul de opbrengsten in die zijn behaald uit geactiveerde productie voor het eigen bedrijf.
                    Geactiveerde productie is de productie van bedrijfsmiddelen in en voor het eigen bedrijf.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingT4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Inkoopkosten, uitbesteed werk en andere externe kosten
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="headingT4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Onder deze kosten vallen onder andere:</p>
                <ul>
                    <li>de inkoopprijs van de verkopen.</li>
                    <li>de kosten van grond- en hulpstoffen.</li>
                    <li>de kosten van uitbesteed werk, bijvoorbeeld de kosten die een agrariër heeft gemaakt voor de
                        werkzaamheden van uitzendbureaus en bedrijfsverzorgingsdiensten.
                    </li>
                    <li>andere externe kosten, zoals winstaandelen die kunnen worden beschouwd als tegenprestaties voor
                        een licentie of een octrooi. Hierbij kan het gaan om betalingen aan een (rechts)persoon die ook
                        aandeelhouder is in de betalende vennootschap. Deze betalingen moeten wel verband houden met
                        verrichte werkzaamheden.
                    </li>
                </ul>

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Personeelskosten
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Lonen en salarissen</b>
                <p>Vul het totale bedrag in aan brutolonen volgens de verzamelloonstaat in de boekhouding. Ontvangen
                    ziektegelden, personeelssubsidies en dergelijke, vermeldt u bij 'Uitkeringen en subsidies'.</p>
                <b>Overige personeelskosten</b>
                <p>Het gaat om de kosten die voor het personeel worden gemaakt, bijvoorbeeld:</p>
                <ul>
                    <li>kosten van voorzieningen voor het personeel (zoals kinderopvang), bijdragen aan
                        personeelsfondsen of -feesten, verstrekte onkostenvergoedingen (voor zover deze niet in het loon
                        zijn opgenomen).
                    </li>
                    <li>reis- en verblijfkosten en representatiekosten, zoals kosten voor dienstreizen en verblijfkosten
                        tijdens die reizen.
                    </li>
                </ul>
                <b>Optierechten</b>
                <p>Vergoedingen in de vorm van aandelen, winstbewijzen en opties op aandelen zijn niet aftrekbaar. Dit
                    geldt ook voor het conversierecht bij een converteerbare (obligatie)lening en de uitreiking of
                    toekenning van een warrant (optierecht) bij een warrantlening.</p>
                <b>Stock Appreciation Rights beperkt aftrekbaar</b>
                <div *ngIf="this.year === 2024">
                    <p>Stock Appreciation Rights zijn beperkt aftrekbaar. Stock Appreciation Rights die de vennootschap
                        heeft toegekend aan werknemers met een jaarloon van meer dan € 699.000 kun je niet
                        aftrekken.</p>
                </div>
                <div *ngIf="this.year === 2023">
                    <p>Stock Appreciation Rights zijn beperkt aftrekbaar. Stock Appreciation Rights die de vennootschap
                        heeft toegekend aan werknemers met een jaarloon van meer dan € 598.000 kun je niet
                        aftrekken.</p>
                </div>
                <b>Ontvangen uitkeringen en subsidies</b>
                <p>Deze uitkeringen en subsidies kun je verwerken bij de post 'Lonen en salarissen' of bij 'Overige
                    personeelskosten'. Het gaat dan om ontvangen ziektegelden, personeelssubsidies en dergelijke.
                    Vermeld ook de ontvangen uitkeringen en subsidies die rechtstreeks aan de vennootschap worden
                    betaald en die worden verstrekt om de arbeidsparticipatie van bijvoorbeeld langdurig werklozen en
                    minder valide mensen te bevorderen.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Afschrijvingen
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Het gaat om afschrijvingen op bedrijfsmiddelen. Voor een omschrijving van het begrip
                    bedrijfsmiddelen, zie de toelichtingen bij de balans - activa.</p>
                <p>De waardevermindering van een bedrijfsmiddel verwerk je volgens goed koopmansgebruik in de fiscale
                    winstberekening door jaarlijkse afschrijving. Het verschil tussen de aanschafwaarde en de restwaarde
                    vormt de afschrijving. Deze spreidt je over de jaren waarin de vennootschap het bedrijfsmiddel
                    gebruikt. De restwaarde is het geschatte bedrag dat de vennootschap aan het einde van de
                    gebruiksduur bij verkoop van het bedrijfsmiddel kan krijgen. De restwaarde van onroerend goed
                    bestaat uit de grondprijs en de eventuele restwaarde van de opstal.</p>
                <p>Je schrijft af naar tijdsgelang. Op een bedrijfsmiddel dat de vennootschap halverwege een jaar hebt
                    aangeschaft, pas je dus de helft van het jaarlijkse afschrijvingsbedrag toe. Er zijn maxima gesteld
                    aan de afschrijvingsbedragen.</p>

                <b>Afschrijving goodwill</b>
                <p>De jaarlijkse afschrijving op goodwill is maximaal 10%.</p>

                <b>Afschrijving gebouwen en terreinen</b>
                <p>Voor het bepalen van de fiscale winst is de normale jaarlijkse afschrijving op gebouwen beperkt. Deze
                    beperking houdt in dat de boekwaarde van een gebouw niet lager mag zijn dan de bodemwaarde.</p>
                <p>Het begrip bodemwaarde is een fiscaal begrip. Het heeft niets te maken met de waarde van de grond.
                    Het is ook niet hetzelfde als de restwaarde.</p>
                <p>Voor alle bedrijfsgebouwen is de bodemwaarde gelijk aan de WOZ-waarde.</p>
                <b>Milieubedrijfsmiddelen en bodemwaarde</b>
                <p>De boekwaarde van een gebouw dat een milieubedrijfsmiddel is en dat de vennootschap op of na 1
                    januari 2009 heeft gekocht, mag lager zijn dan de bodemwaarde. Als de vennootschap in het
                    kalenderjaar 2007 of 2008 onroerende zaken heeft aangeschaft die een milieubedrijfsmiddel zijn, moet
                    je (ook in latere jaren) rekening blijven houden met de bodemwaarde.</p>
                <b>Bedrijfsterreinen</b>
                <p>Omdat grond en (bedrijfs)terreinen niet slijten, kun jedaarop niet afschrijven. Wel kun je
                    afschrijven op verbeteringen aan de (bedrijfs)terreinen zoals erfverhardingen, drainage, damwanden
                    e.d.</p>

                <b>Afschrijving machines en installaties</b>
                <p>De jaarlijkse afschrijving op bedrijfsmiddelen is maximaal 20% van de aanschaf- of
                    voortbrengingskosten.</p>
                <div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <p><u>Voorbeeld</u></p>
                    <p>De aanschafwaarde van een computer is € 1.000. De levensduur van de computer is 3 jaar. De
                        restwaarde is € 100.<br/>
                        De economische afschrijving is (€ 1.000 -/- € 100) / 3 = € 300 per jaar.<br/>
                        De fiscale afschrijving is echter maximaal 20% van € 1.000 = € 200 per jaar.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Bedrijfskosten
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Van de opbrengsten mag de vennootschap de zakelijke kosten aftrekken. Alleen de kosten die de
                    vennootschap maakt
                    voor de zakelijke belangen van de onderneming, zijn aftrekbaar: de zakelijke kosten. Zakelijke
                    kosten zijn dus de kosten die binnen redelijke grenzen nodig zijn voor de uitoefening van de
                    onderneming en de kosten die rechtstreeks op de onderneming betrekking hebben. Alle andere kosten
                    zijn niet aftrekbaar.</p>

                <p>Zakelijke kosten kun je helemaal aftrekken van de opbrengsten. Eventuele vergoedingen die de
                    vennootschap voor de kosten heeft ontvangen, moet je bij de opbrengsten tellen.</p>

                <b>Zakelijke kosten: geen toetsing van beleid</b>
                <p>Bij de beoordeling van de vraag of kosten aftrekbaar zijn, let de Belastingdienst op het motief
                    waarmee de vennootschap kosten
                    hebt gemaakt. Als duidelijk is dat de vennootschap de kosten volledig hebt gemaakt voor de zakelijke
                    belangen van
                    uw onderneming, accepteert de Belastingdienst de kosten als aftrekpost.</p>

                <b>Kosten aftrekken met of zonder btw?</b>
                <p>Als je uitgaven doet voor uw onderneming, brengt de leverancier vaak btw in rekening. Meestal kan de
                    vennootschap deze btw terugkrijgen (de zogeheten aftrek van voorbelasting). In dat geval trekt je
                    bij de winstberekening de kosten af exclusief btw. Soms kan de vennootschap de btw niet aftrekken.
                    Dan mag je bij de winstberekening de kosten aftrekken inclusief btw. Lees meer hierover op de <a
                            href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/zakelijk/btw/btw_aftrekken/welke_btw_is_aftrekbaar/welke_btw_mag_u_niet_aftrekken"
                            target="_blank">site van de Belastingdienst</a>.
                </p>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading8">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                Financiële baten en lasten
            </button>
        </h2>
        <div id="collapse8" class="accordion-collapse collapse" aria-labelledby="heading8"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Onder de financiële baten en lasten vallen bijvoorbeeld:</p>
                <ul style="list-style: disc;">
                    <li>opbrengsten van vorderingen op groepsmaatschappijen.</li>
                    <li>opbrengsten van vorderingen op participanten en maatschappijen waarin wordt deelgenomen.</li>
                    <li>opbrengsten banktegoeden.</li>
                    <li>ontvangen dividend (niet van deelnemingen).</li>
                    <li>kwijtscheldingswinst.</li>
                    <li>waardeverandering van vorderingen.</li>
                    <li>waardeverandering van effecten.</li>
                    <li>opbrengsten van overige vorderingen.</li>
                    <li>kosten van schulden aan groepsmaatschappijen.</li>
                    <li>kosten van schulden aan participanten en maatschappijen waarin wordt deelgenomen.</li>
                    <li>kosten van schulden, rentelasten en soortgelijke kosten.</li>
                </ul>

                <b>Kwijtscheldingswinst</b>
                <p>Vermeld de winst die is ontstaan doordat een crediteur afzag van zijn vorderingsrecht op een bedrag
                    dat u moest betalen.</p>
                <p>Als een schuldeiser schulden kwijtscheldt, levert dit in principe winst op voor de vennootschap. Deze
                    winst is onder bepaalde voorwaarden vrijgesteld. De belangrijkste voorwaarde is dat de schuldeiser
                    de rechten prijsgeeft die niet zijn te verwezenlijken. De winst die de vennootschap behaalt door de
                    kwijtschelding, is slechts vrijgesteld voor zover deze hoger is dan de te verrekenen verliezen van
                    vorige boekjaren en van het boekjaar zelf. Verliezen in boekjaren die volgen op het boekjaar van de
                    kwijtschelding, verkleinen het vrijgestelde bedrag niet.
                </p>
                <b>Waardeverandering van vorderingen</b>
                <p>Vul hier de op- of afwaardering in van vorderingen.<br/>
                    Opwaardering kan bijvoorbeeld plaatsvinden als de vennootschap een vordering heeft in een andere
                    valuta dan de euro, en de koers van die valuta is gestegen.
                    <br/><br/>
                    Afwaardering kan bijvoorbeeld plaatsvinden omdat een debiteur niet kan betalen (insolvabiliteit).
                    Houd hierbij rekening met de eventuele toevoeging aan de winst in de zin van artikel 13b en 13ba
                    Vpb. Het gaat hierbij om situaties waarin een vordering op een deelneming is afgewaardeerd ten laste
                    van de Nederlandse winst en een belaste waardestijging vervolgens geheel of gedeeltelijk onmogelijk
                    wordt gemaakt. De toevoeging aan de winst op grond van artikel 13ba Vpb hoeft niet onmiddellijk tot
                    te betalen belasting te leiden. De schuldeiser kan namelijk een opwaarderingsreserve vormen voor het
                    bedrag van de afwaardering. De opwaarderingsreserve wordt jaarlijks aan de winst toegevoegd voor
                    zover het verschil tussen de actuele waarde in het economische verkeer van de deelneming en de
                    waarde in het economische verkeer van de deelneming op het moment van de omzetting, kwijtschelding
                    of het gaan functioneren als eigen vermogen uitgaat boven het bedrag waarmee de opwaarderingsreserve
                    sinds dat moment is afgenomen.
                    <br/><br/>
                    Hebt de vennootschap een lening verstrekt binnen concernverband, bijvoorbeeld aan de aandeelhouder,
                    dochtermaatschappij of zustermaatschappij? En loopt de vennootschap daarbij een debiteurenrisico dat
                    een onafhankelijke derde niet zou lopen (onzakelijk debiteurenrisico)? Dan mag de vennootschap een
                    afwaardering van de vordering niet ten laste van de winst brengen.
                </p>

                <b>Waardeverandering van effecten</b>
                <p>
                    Vermeld de koerswinst of het koersverlies van de effecten die geen deelneming vormen. Ga hierbij uit
                    van het waarderingsstelsel dat de vennootschap hanteert voor deze effecten.
                </p>

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading9">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
                Buitengewone baten en lasten
            </button>
        </h2>
        <div id="collapse9" class="accordion-collapse collapse" aria-labelledby="heading9"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Let op! Vermeld hier niet de wijzigingen in toelaatbare reserves. Deze vul je in onder 'Balans
                    passiva' bij de fiscale reserves.</p>

                <p>Onder de buitengewone baten en lasten vallen onder andere:</p>
                <ul>
                    <li>voordelen door ontvoeging dochtermaatschappij of beëindiging fiscale eenheid.</li>
                    <li>boekwinst op activa.</li>
                    <li>overige buitengewone baten.</li>
                    <li>afboeking herinvesteringsreserve op gekochte activa.</li>
                    <li>boekverlies op activa.</li>
                    <li>overige buitengewone lasten.</li>
                </ul>

                <b>Voordelen door ontvoeging dochtermaatschappij of beëindiging fiscale eenheid</b>
                <p>Bedoeld wordt de situatie in de zin van artikel 13, lid 2 Besluit fiscale eenheid.
                    <br/>
                    Het einde van de fiscale eenheid kan leiden tot een aantal zogenoemde exitheffingen. Om een juiste
                    toepassing van deze exitheffingen te waarborgen, moet de moedermaatschappij de winst afzonderlijk
                    weergeven in de aangifte over het jaar van de ontvoeging.
                </p>
                <b>Boekwinst op activa</b>
                <p>Bedoeld wordt de situatie in de zin van artikel 13, lid 2 Besluit fiscale eenheid.
                    <br/>
                    Vul de boekwinst op de verkochte activa in, ook als je deze boekwinst toevoegt aan de
                    herinvesteringsreserve.
                </p>
                <b>Afboeking herinvesteringsreserve op gekochte activa</b>
                <p>Het gaat om de situatie waarbij de vennootschap een bedrijfsmiddel heeft aangeschaft. De boekwinst
                    die de vennootschap hebt
                    behaald bij de eerdere verkoop van een bedrijfsmiddel, boek je af op de aanschafprijs van het nieuwe
                    bedrijfsmiddel.<br/>
                    Vul het bedrag in waarmee ke de aanschafprijs van het nieuwe bedrijfsmiddel hebt afgeboekt.
                    Let op! Je moet dit bedrag ook invullen bij 'Balans passiva' bij het onderdeel
                    'Herinvesteringsreserve'.
                </p>

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading10">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse10" aria-expanded="false" aria-controls="collapse10">
                Resultaat deelnemingen
            </button>
        </h2>
        <div id="collapse10" class="accordion-collapse collapse" aria-labelledby="heading10"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Winsten en verliezen uit een deelneming maken in het algemeen geen deel uit van de belastbare winst
                    (deelnemingsvrijstelling). Met de deelnemingsvrijstelling voorkom je dat winst die al eerder is
                    belast bij een dochtermaatschappij, nog een keer wordt belast bij de moedermaatschappij.</p>
                <p>Bij winsten gaat het bijvoorbeeld om ontvangen dividend en om winst bij verkoop van een deelneming.
                    Bij verliezen gaat het bijvoorbeeld om verlies bij verkoop van een deelneming. De winsten zijn in
                    dit geval niet belast. De verliezen zijn niet aftrekbaar. Aan- en verkoopkosten van een deelneming
                    zijn niet aftrekbaar.</p>
                <p>Er is sprake van een deelneming in de volgende gevallen:</p>
                <ul>
                    <li>De vennootschap is voor ten minste 5% van het nominaal gestorte kapitaal aandeelhouder van een
                        vennootschap
                        waarvan het kapitaal geheel of gedeeltelijk in aandelen is verdeeld (bijvoorbeeld een naamloze
                        of besloten vennootschap).
                    </li>
                    <li>De vennootschap bezit ten minste 5% van het aantal bewijzen van deelgerechtigdheid dat in omloop
                        is in een fonds voor gemene rekening.
                    </li>
                    <li>De vennootschap is lid van een coöperatie of van een vereniging op coöperatieve grondslag.</li>
                    <li>De vennootschap neemt als commanditair vennoot voor ten minste 5% deel in een open commanditaire
                        vennootschap.
                    </li>
                    <li>De vennootschap bezit aandelen die een stemrecht van ten minste 5% vertegenwoordigen in een
                        vennootschap die in een EU-lidstaat is gevestigd. Voorwaarde hierbij is dat met deze lidstaat
                        een verdrag ter voorkoming van dubbele belasting is gesloten dat voorziet in een verlaging van
                        belastingheffing op dividenden op grond van het aantal stemrechten.
                    </li>
                    <li>De vennootschap is een deelneming door gelijkstelling (meesleepregeling).</li>
                    <li>De vennootschap heeft een deelneming door de meetrekregeling.</li>
                </ul>
                <p>Een aandelenbezit van minder dan 5% kan geen deelneming vormen. Er is 1 uitzondering: Als een
                    deelneming van ten minste 5% na een bezit van meer dan 1 jaar daalt onder het 5%-niveau, dan is de
                    deelnemingsvrijstelling nog 3 jaar van toepassing.</p>

                <b>Deelnemingsvrijstelling</b>
                <p>
                    Winsten en verliezen uit een deelneming maken in het algemeen geen deel uit van de belastbare winst.
                    Met de deelnemingsvrijstelling voorkomt u dat winst die al eerder is belast bij een
                    dochtermaatschappij, nog een keer wordt belast bij de moedermaatschappij.
                    <br/><br/>
                    Bij winsten gaat het bijvoorbeeld om ontvangen dividend en om winst bij verkoop van een deelneming.
                    Bij verliezen gaat het bijvoorbeeld om verlies bij verkoop van een deelneming. De winsten zijn in
                    dit geval niet belast. De verliezen zijn niet aftrekbaar.
                    <br/><br/>
                    Aan- en verkoopkosten vallen ook onder de deelnemingsvrijstelling en zijn dus niet aftrekbaar.
                    <br/><br/>
                    De deelnemingsvrijstelling is niet van toepassing op een <a
                        href="https://www.belastingdienst.nl/data/online_aangifte/vpb/vpb2022/meer_info/kwalificerende_beleggingsdeelneming.htm"
                        target="_blank">niet-kwalificerende beleggingsdeelneming </a>. In dat geval is
                    deelnemingsverrekening mogelijk. Vanaf het moment dat een deelneming wijzigt in een
                    niet-kwalificerende beleggingsdeelneming, is de deelnemingsvrijstelling niet meer van toepassing.
                    <br/><br/>
                    Als er sprake is van een kwalificerende beleggingsdeelneming, geldt de deelnemingsvrijstelling wel.
                    <br/><br/>
                    De deelnemingsvrijstelling geldt niet als je aangifte doet voor een beleggingsinstelling.
                </p>
            </div>
        </div>
    </div>

</div>
